﻿import { onlyDigits } from "@js/core/utils/text";
import { t, currentLang } from "@js/core/utils/i18n";

let validatorsRegistered = false;

export function initParsleyLocale(locale = currentLang()) {
    if (!window.Parsley) return;

    try {
        window.Parsley.setLocale(locale);
    } catch (_) {
        // ignore
    }
}

export function registerCommonValidators() {
    if (!window.Parsley || validatorsRegistered) return;

    window.Parsley.addValidator("vknOrTckn", {
        validateString(value) {
            const digits = onlyDigits(value);
            return digits.length === 10 || digits.length === 11;
        },
        messages: {
            [currentLang()]: t("Validation.VknOrTckn")
        }
    });

    validatorsRegistered = true;
}

export function initParsleyForm(formSelector, options = {}) {
    if (!window.jQuery || !window.Parsley) return null;

    const $ = window.jQuery;
    const $form = $(formSelector);

    if (!$form.length) return null;

    return $form.parsley({
        errorClass: "is-invalid",
        successClass: "is-valid",
        classHandler(field) {
            return field.$element.closest(".field");
        },
        errorsContainer(field) {
            return field.$element.closest(".field");
        },
        ...options
    });
}